import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const FilterIcon = ({ size = 16, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 1.18808C0 0.87298 0.122916 0.570787 0.341709 0.34798C0.560501 0.125172 0.857247 0 1.16667 0H12.8333C13.1428 0 13.4395 0.125172 13.6583 0.34798C13.8771 0.570787 14 0.87298 14 1.18808V2.8403C13.9999 3.26039 13.836 3.66325 13.5442 3.96026L9.33333 8.24842V14.1286C9.33335 14.2771 9.29609 14.4232 9.22508 14.5529C9.15407 14.6827 9.05166 14.7918 8.9276 14.8699C8.80353 14.9479 8.66193 14.9924 8.51622 14.9991C8.37052 15.0058 8.22556 14.9744 8.09511 14.908L5.20411 13.4364C5.04262 13.3541 4.9068 13.2277 4.81188 13.0713C4.71696 12.9149 4.66667 12.7347 4.66667 12.5508V8.24842L0.455778 3.96026C0.164034 3.66325 8.81026e-05 3.26039 0 2.8403V1.18808ZM1.55556 1.5841V2.8403L5.88 7.2441C5.98846 7.35441 6.07451 7.48541 6.13323 7.62961C6.19195 7.7738 6.22219 7.92837 6.22222 8.08447V12.1833L7.77778 12.9754V8.08447C7.77778 7.76923 7.90067 7.46667 8.12 7.24489L12.4444 2.8395V1.5841H1.55556Z"
            fill={props.color || "currentColor"}
        />
    </svg>
);
export default FilterIcon;
